import { ReachAPI } from './ReachAPI';
import { glom } from '../Signage/glom';
import { Log } from '../AuxillaryService/Log';

/**
 * @class widget
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.widget = {};

/**
 * GET Endpoint `/widget/iframe/login_logic`
 * @param {string} name
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.widget
 */
ReachAPI.widget.getIframeLoginLogic = function (name) {
    var url = ReachAPI.server + '/widget/iframe/login_logic';
    var params = {
        name: name,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved LoginLogic (' + name + ') from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved LoginLogic (' + name + ') from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve LoginLogic (' + name + ')',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/widget/iframe/login_sequence`
 * @param {string} name
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.widget
 */
ReachAPI.widget.getIframeLoginSequence = function (name) {
    var url = ReachAPI.server + '/widget/iframe/login_sequence';
    var params = {
        name: name,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved login sequence (' + name + ') from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved login sequence (' + name + ') from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve login sequence (' + name + ')',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/widget/iframe/send_login_sequence_email`
 * @param {string} emailAddress
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.widget
 */
ReachAPI.widget.sendLoginSequenceEmail = function (emailAddress) {
    var url = ReachAPI.server + '/widget/iframe/send_login_sequence_email';
    var params = {
        email_address: emailAddress,
        player_uuid: glom.playerUuid,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Info(
                'Sent login sequence email (' + emailAddress + ') from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Info(
                'Sent login sequence email (' + emailAddress + ') from the API',
                null,
                __fileline
            );
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to send login sequence email (' + emailAddress + ')',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
